import { useEffect, useState } from "react";
import api, { fmtDT, fmtDate } from "@/lib/api";
import { PageHeader, StatusBadge, Loading, EmptyState } from "@/components/Shared";
import { Truck } from "lucide-react";
import OrdersExportBar from "@/components/OrdersExportBar";
import { DeliveryBadge, DeliveryUpdater } from "@/components/DeliveryStatus";

export default function AdminOrders() {
  const [orders, setOrders] = useState(null);
  const [opId, setOpId] = useState("");
  const [gId, setGId] = useState("");
  useEffect(() => { api.get("/admin/orders").then((r) => setOrders(r.data)).catch(() => setOrders([])); }, []);
  if (orders === null) return <Loading />;
  const shown = orders.filter((o) => (!opId || o.operation_id === opId) && (!gId || o.grossiste_id === gId));

  const onUpdated = (id, newStatus) => {
    setOrders((prev) => prev.map((o) => o.id === id ? { ...o, delivery_status: newStatus } : o));
  };

  return (
    <div>
      <PageHeader title="Commandes" subtitle="Toutes les participations validées sur la plateforme." />
      <OrdersExportBar opId={opId} setOpId={setOpId} gId={gId} setGId={setGId} />
      {shown.length === 0 ? <EmptyState title="Aucune commande" icon={Truck} /> : (
        <div className="bg-white border border-slate-200 rounded-xl overflow-hidden overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 text-left"><tr>
              <th className="px-5 py-3 font-semibold">Pharmacie</th><th className="px-5 py-3 font-semibold">Opération</th><th className="px-5 py-3 font-semibold">Fournisseur</th><th className="px-5 py-3 font-semibold">Grossiste livreur</th><th className="px-5 py-3 font-semibold text-right">Montant</th><th className="px-5 py-3 font-semibold">Date</th><th className="px-5 py-3 font-semibold">Livraison</th>
            </tr></thead>
            <tbody className="divide-y divide-slate-100">
              {shown.map((o) => (
                <tr key={o.id} className="hover:bg-slate-50 transition-colors duration-200" data-testid={`admin-order-${o.id}`}>
                  <td className="px-5 py-3 font-semibold text-slate-900">{o.pharmacist_name}</td>
                  <td className="px-5 py-3 text-slate-600">{o.operation_name}</td>
                  <td className="px-5 py-3 text-slate-500">{o.supplier_name}</td>
                  <td className="px-5 py-3 text-slate-600 font-medium">{o.grossiste_name || "—"}</td>
                  <td className="px-5 py-3 text-right num font-bold text-slate-900">{fmtDT(o.total_amount)}</td>
                  <td className="px-5 py-3 text-slate-400">{fmtDate(o.created_at)}</td>
                  <td className="px-5 py-3">
                    <div className="flex items-center gap-2">
                      <DeliveryBadge status={o.delivery_status} />
                      <DeliveryUpdater participationId={o.id} current={o.delivery_status || "ordered"} onUpdated={(s) => onUpdated(o.id, s)} testId={`admin-set-delivery-${o.id}`} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
